/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AssistantExecutionProfile,
  AssistantExecutionProfile$inboundSchema,
} from "./assistantexecutionprofile.js";

export type ListExecutionProfilesResult = {
  /**
   * Each root trigger and execution context.
   */
  profiles: Array<AssistantExecutionProfile>;
};

/** @internal */
export const ListExecutionProfilesResult$inboundSchema: z.ZodMiniType<
  ListExecutionProfilesResult,
  unknown
> = z.object({
  profiles: z.array(AssistantExecutionProfile$inboundSchema),
});

export function listExecutionProfilesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListExecutionProfilesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListExecutionProfilesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListExecutionProfilesResult' from JSON`,
  );
}
